import hActionsheet from './actionsheet/index.vue';
import hActivePcard from './active-pcard/index.vue';
import hBackTop from './back-top/index.vue';
import hBrandBox from './brand-box/index.vue';
import hButton from './button/index.vue';
import hCounter from './counter/index.vue';
import { hDialog } from './dialog/index.js';
import hDropArea from './drop-area/index.vue';
import hEvaluate from './evaluate/index.vue';
import { hGoodsAction, hGoodsActionButton, hGoodsActionIcon } from './goods-action/index.js';
import hHead from './head/index.vue';
import hIcon from './icon/index.vue';
import hImage from './image/index.vue';
import { ImagePreview, hImagePreview } from './image-preview/index.js';
import hInfo from './info/index.vue';
import { hCol, hRow } from './layout/index.js';
import hLoading from './loading/index.vue';
import { hMenu, hMenuItem } from './menu/index.js';
import hMenuBox from './menu-box/index.vue';
import hMyOrder from './my-order/index.vue';
import hNoticeBar from './notice-bar/index.vue';
import hOrderCard from './order-card/index.vue';
import hOrderShop from './order-shop/index.vue';
import hOrderTips from './order-tips/index.vue';
import hOverlay from './overlay/index.vue';
import hPopup from './popup/index.vue';
import hProductCard from './product-card/index.vue';
import hPurList from './pur-list/index.vue';
import hQqMap from './qq-map/index.vue';
import hRate from './rate/index.vue';
import hSearch from './search/index.vue';
import hSettlementBar from './settlement-bar/index.vue';
import hShopCarCard from './shop-car-card/index.vue';
import hShopCard from './shop-card/index.vue';
import hShopMessage from './shop-message/index.vue';
import hShopZone from './shop-zone/index.vue';
import { hSteps, hStep } from './steps/index.js';
import { hSwipe, hSwipeItem } from './swipe/index.js';
import hSwipeCell from './swipe-cell/index.vue';
import { hTabbar, hTabbarItem } from './tabbar/index.js';
import { hToast } from './toast/index.js';


const components = [
	hActionsheet,
	hActivePcard,
	hBackTop,
	hBrandBox,
	hButton,
	hCounter,
	hDialog,
	hDropArea,
	hEvaluate,
	hGoodsAction, hGoodsActionButton, hGoodsActionIcon,
	hHead,
	hIcon,
	hImage,
	ImagePreview, hImagePreview,
	hInfo,
	hCol, hRow,
	hLoading,
	hMenu, hMenuItem,
	hMenuBox,
	hMyOrder,
	hNoticeBar,
	hOrderCard,
	hOrderShop,
	hOrderTips,
	hOverlay,
	hPopup,
	hProductCard,
	hPurList,
	hQqMap,
	hRate,
	hSearch,
	hSettlementBar,
	hShopCarCard,
	hShopCard,
	hShopMessage,
	hShopZone,
	hSteps, hStep,
	hSwipe, hSwipeItem,
	hSwipeCell,
	hTabbar, hTabbarItem,
	hToast,
];

// 组件添加注册方法
components.forEach(component => {
    component.install = function( Vue ) {
        Vue.component(component.name, component);
    }
});

/**
 * 可全局注册使用
 */
const install = function(Vue) {
    components.forEach(component => {
        Vue.component(component.name, component);
    });
};
  
/* istanbul ignore if */
if ( typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export {
    install,
	hActionsheet,
	hActivePcard,
	hBackTop,
	hBrandBox,
	hButton,
	hCounter,
	hDialog,
	hDropArea,
	hEvaluate,
	hGoodsAction, hGoodsActionButton, hGoodsActionIcon,
	hHead,
	hIcon,
	hImage,
	ImagePreview, hImagePreview,
	hInfo,
	hCol, hRow,
	hLoading,
	hMenu, hMenuItem,
	hMenuBox,
	hMyOrder,
	hNoticeBar,
	hOrderCard,
	hOrderShop,
	hOrderTips,
	hOverlay,
	hPopup,
	hProductCard,
	hPurList,
	hQqMap,
	hRate,
	hSearch,
	hSettlementBar,
	hShopCarCard,
	hShopCard,
	hShopMessage,
	hShopZone,
	hSteps, hStep,
	hSwipe, hSwipeItem,
	hSwipeCell,
	hTabbar, hTabbarItem,
	hToast,
}

export default {
    install
}
